


const closeMenu = () => {
    document.body.dataset.menu = 'closed';
};

const openMenu = () => {
    document.body.dataset.menu = 'open';
};

const toogleMenu = () => {
    let isOpen = document.body.dataset.menu === 'open';
    if (isOpen) {
        closeMenu();
    } else {
        openMenu();
    }
};


function initMenu() {
    const backgroundElement = document.querySelector('.menu');
    if (backgroundElement) {
        backgroundElement.addEventListener('click', event => {
            event.preventDefault();
            toogleMenu();
        });
    }

    const closeElement = document.getElementById('menu-close');
    if (closeElement) {
        closeElement.addEventListener('click', event => {
            event.preventDefault();
            toogleMenu();
        });
    }
}

{
    const slider = require('./slider');
    const screen = slider.screen;
    const slides = slider.slides;
    
    let menuLinks = document.querySelectorAll('a[href^="#month-"]');
    menuLinks = Array.from(menuLinks);
    
    menuLinks.forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
    
            screen.goTo( slides[link.dataset.slide]);
            closeMenu();
        })
    });

    slider.on('ready', () => {
        initMenu();
    }, this, true);
}


// WEBPACK FOOTER //
// ./js/menu.js